(function($){
	$('.lpDonor__section7__carousel').slick({
		dots: true,
		infinite: true,
	});
	$('#popoverDonorBmi').popover();
}(jQuery));